module.exports = __webpack_public_path__ + "media/npc_dota_hero_treant.120e904e.webm";